import React, { useState } from "react";
import { Rocket, ArrowRight, X, Check } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function ComingSoonBanner() {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      const r = await api.post("/waitlist", { email, source: "terminal-banner" });
      setDone(true);
      toast.success(r.data.already ? "You're already on the list!" : "You're in! We'll email when the Terminal opens.");
      setTimeout(() => { setOpen(false); setDone(false); setEmail(""); }, 2500);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Please enter a valid email");
    } finally { setBusy(false); }
  };

  return (
    <>
      <div className="w-full bg-gradient-to-r from-[#D91E2A] via-[#B01820] to-[#8B1015] text-white" data-testid="coming-soon-banner">
        <div className="px-4 sm:px-6 lg:px-12 py-4 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-white/15 flex items-center justify-center border border-white/20 shrink-0">
              <Rocket className="w-5 h-5" />
            </div>
            <div>
              <div className="text-[10px] font-mono-fin uppercase tracking-[0.25em] text-white/70 font-bold">Coming Soon</div>
              <div className="font-heading font-bold text-base sm:text-lg tracking-tight">Nivesh Street Terminal — Every Indian market, one intelligent screen.</div>
            </div>
          </div>
          <button onClick={() => setOpen(true)} className="flex items-center gap-1.5 text-sm font-semibold bg-white text-[#D91E2A] px-4 py-2 rounded-md hover:bg-white/90 shrink-0" data-testid="terminal-waitlist-btn">
            Join Waitlist <ArrowRight className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>

      {open && (
        <div className="fixed inset-0 z-50 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center p-4" onClick={() => setOpen(false)}>
          <div className="w-full max-w-md rounded-xl bg-white shadow-2xl overflow-hidden" onClick={e => e.stopPropagation()} data-testid="waitlist-modal">
            <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200">
              <div className="flex items-center gap-2">
                <Rocket className="w-4 h-4 text-[#D91E2A]" />
                <span className="text-xs font-mono-fin uppercase tracking-widest text-[#D91E2A] font-bold">Early Access</span>
              </div>
              <button onClick={() => setOpen(false)} className="p-1 rounded hover:bg-slate-100"><X className="w-4 h-4" /></button>
            </div>
            <div className="px-6 py-6">
              {done ? (
                <div className="text-center py-6">
                  <div className="w-14 h-14 mx-auto rounded-full bg-emerald-100 flex items-center justify-center mb-3">
                    <Check className="w-7 h-7 text-emerald-600" />
                  </div>
                  <div className="font-heading font-bold text-xl text-slate-900">You're on the list.</div>
                  <p className="text-sm text-slate-600 mt-1">We'll notify {email} the day the Terminal ships.</p>
                </div>
              ) : (
                <form onSubmit={submit}>
                  <h2 className="font-heading font-bold text-2xl text-slate-900 mb-1">Join the Terminal Waitlist</h2>
                  <p className="text-sm text-slate-600 mb-5">Get early access to Nivesh Street Terminal — the first Indian markets desk built for retail investors.</p>
                  <input
                    autoFocus
                    type="email"
                    required
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="you@example.com"
                    className="w-full px-4 py-3 rounded-md border border-slate-200 bg-slate-50 text-slate-900 font-mono-fin focus:outline-none focus:border-[#D91E2A]"
                    data-testid="waitlist-email-input"
                  />
                  <button type="submit" disabled={busy} className="w-full mt-3 px-4 py-3 rounded-md bg-[#D91E2A] hover:bg-[#B01820] text-white font-semibold flex items-center justify-center gap-2 disabled:opacity-60" data-testid="waitlist-submit">
                    {busy ? "Adding you…" : "Reserve My Seat"} <ArrowRight className="w-4 h-4" />
                  </button>
                  <p className="text-[11px] text-slate-500 mt-3 text-center">No spam. Unsubscribe anytime.</p>
                </form>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
